import { isTicket, TicketModel } from '@/v2/models/ticketModel';
import { EventModel } from '@/v2/models/eventModel';
import { isProduct, ProductModel } from '@/v2/models/productModel';
import _ from 'lodash';

export type EventItemsModel = {
  event: EventModel;
  tickets: TicketModel[];
  products: ProductModel[];
};

export const orderItems = (items: { voidedAt?: object }[]) => {
  const tickets = _.filter(items, isTicket);
  const products = _.filter(items, isProduct);
  const activeTickets = _.filter(tickets, (ticket: TicketModel) => !!!ticket.voidedAt);
  const activeProducts = _.filter(products, (product: ProductModel) => !!!product.voidedAt);
  const voidedTickets = _.filter(tickets, (ticket: TicketModel) => !!ticket.voidedAt);
  const voidedProducts = _.filter(products, (product: ProductModel) => !!product.voidedAt);
  return [...activeTickets, ...activeProducts, ...voidedTickets, ...voidedProducts];
};
